
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[url]",
      function () {
        return require("private-next-pages/[url]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[url]"])
      });
    }
  